module.exports = __webpack_public_path__ + "img/assets-18.73338f37.png";